// eslint-disable-next-line no-restricted-imports
import { Popover as MuiPopover, PopoverProps as MuiPopoverProps } from '@material-ui/core';
import { Theme } from '@emotion/react';
import { paper } from 'omakase/Popover/popoverCssDefs';
import React from 'react';

export interface PopoverProps extends MuiPopoverProps {
  minWidthPx?: number;
  maxWidthPx?: number;
}

const Popover: React.FunctionComponent<PopoverProps> = ({
  children,
  minWidthPx,
  maxWidthPx,
  ...rest
}) => {
  return (
    <MuiPopover {...rest} css={(theme: Theme) => paper(theme, minWidthPx, maxWidthPx)}>
      {children}
    </MuiPopover>
  );
};

export default Popover;
